<template>
  <div class="jsonretro">
    <div class="jsonretro__json-container">
      <pre class="jsonretro__json">{{ retroJson | pretty }}</pre>
    </div>
  </div>
</template>

<script>
import jsonMaker from '@/services/jsonMaker'
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  filters: {
    pretty: function(value) {
      if (!value)
        return ''
      return JSON.stringify(value, null, 2);
    }
  },
  computed: {
    retroJson() {
      return jsonMaker.mount(this.form)
    }
  },
  watch: {
    retroJson(newJson) {
      this.$emit("json-updated", newJson)
    }
  }
}
</script>

<style>

.jsonretro__json-container {
  background-color: #F9F9FA;
  padding: 20px;
  margin: 10px;
}

pre {
  white-space: pre-wrap; /* css-3 */ 
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */ 
  white-space: -pre-wrap; /* Opera 4-6 */ 
  white-space: -o-pre-wrap; /* Opera 7 */ 
  word-wrap: break-word; /* Internet Explorer 5.5+ */ 
}
</style>